module.exports = {"platforms":[{"type":"FiniteImmobilePlatform","x":96,"y":480,"width":576,"height":128,"display":{"assetName":"temple"}}],"goal":{"x":512,"y":480},"player":{"x":256,"y":350}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/json-loader!./levels/beta-0.json
// module id = 119
// module chunks = 0